export const teamResilienceDefaultCategory = {
    TeamResources: 'Team Resources',
    MinimizingFactors: 'Minimizing Factors',
    MendingEfforts: 'Mending Efforts',
    ResilienceManifestation: 'Resilience Manifestation',
    Stressors: 'Stressors',
};

export const teamResilienceDefaultTeamResourcesSubCategory = {
    Physical: 'Physical',
    Affective: 'Affective',
    Cognitive: 'Cognitive',
};

export const teamResilienceDefaultStressorsSubCategory = {
    Psychological: 'Psychological',
    External: 'External',
    Workload: 'Workload',
};

export const teamResilienceDefaultInstructions =
    "1. For questions 1 to 12, choose the number that describes your team's current resource level by using the 1-100 rating scale.\n" +
    '2. For questions 13 onwards, rate each question as it relates to you and your team.';

export const teamResilienceDefaultReminders =
    'The only right answer is the honest one, so be true to yourself in your response.';

export const teamResilienceTeamResourceInstruction =
    'Using the 10\u2010100 current resource level scale, please choose the number that describes your team for each of the team resources listed below.';

export const teamResilienceMinimizingFactorsInstruction = 'Use the scale below to rate your team.';

export const teamResilienceMendingEffortsInstruction = 'Use the scale below to answer the questions about your team.';

export const teamResilienceResilienceManifestationInstruction =
    'Use the scale below to answer the questions about your team.';

export const teamResilienceStressorsInstruction =
    'Please use the scale below to assess the challenges and stressors your team experienced at work during the last month.';

export const teamResilienceMinimizingFactorsScoring = [
    { score: 1, label: 'Not At All' },
    { score: 2, label: 'A Little Extent' },
    { score: 3, label: 'To Some Extent' },
    { score: 4, label: 'To A Great Extent' },
    { score: 5, label: 'To A Very Great Extent' },
];

export const teamResilienceMendingEffortsScoring = [
    { score: 1, label: 'No Need To Demonstrate This Behavior' },
    { score: 2, label: 'Never Or Rarely' },
    { score: 3, label: 'Some Of The Time' },
    { score: 4, label: 'Most Of The Time' },
    { score: 5, label: 'Every Time' },
];

export const teamResilienceStressorsScoring = [
    { score: 1, label: 'Never' },
    { score: 2, label: 'Rarely' },
    { score: 3, label: 'Occasionally' },
    { score: 4, label: 'Frequently' },
    { score: 5, label: 'Constantly' },
];

export const teamResilienceTeamResourceQuestions = [
    'Rest',
    'Energy',
    'Physical Fitness',
    'Endurance',
    'Mutual Trust',
    'Morale',
    'Motivation',
    'Composure',
    'Task or mission-related knowledge',
    'Shared situational awareness',
    'Alertness',
    'Mental readiness',
];

export const teamResilienceTeamResourceSubCategories = [
    teamResilienceDefaultTeamResourcesSubCategory.Physical,
    teamResilienceDefaultTeamResourcesSubCategory.Physical,
    teamResilienceDefaultTeamResourcesSubCategory.Physical,
    teamResilienceDefaultTeamResourcesSubCategory.Physical,
    teamResilienceDefaultTeamResourcesSubCategory.Affective,
    teamResilienceDefaultTeamResourcesSubCategory.Affective,
    teamResilienceDefaultTeamResourcesSubCategory.Affective,
    teamResilienceDefaultTeamResourcesSubCategory.Affective,
    teamResilienceDefaultTeamResourcesSubCategory.Cognitive,
    teamResilienceDefaultTeamResourcesSubCategory.Cognitive,
    teamResilienceDefaultTeamResourcesSubCategory.Cognitive,
    teamResilienceDefaultTeamResourcesSubCategory.Cognitive,
];

export const teamResilienceMinimizingFactorsQuestions = [
    'Been adequately staffed to handle future challenges?',
    'Been adequately resourced to manage future challenges?',
    'Been adequately trained to manage future challenges?',
    'Developed plans to handle different potential challenges?',
    'Developed strong working relationships with one another?',
    'Adequately assessed its preparedness for future challenges?',
];

export const teamResilienceMendingEffortsQuestions = [
    'Adequately assessed its preparedness for future challenges?',
    'Worked through areas of conflict that may have developed between team members as a result of the challenges or stressors',
    'Communicated appreciation for helpful actions taken by team members when facing the challenges or stressors',
    'Helped individual team members who were affected by the challenging event or stressor',
    'Repaired relationships with people outside the team that might have been strained',
    'Thanked people outside the team for their help and support',
    'Identified how to address future challenges (for example: who will fill in or help out if X happens, how they will address future needs)',
    'Agreed how to follow up to ensure progress',
    'Made changes to processes, procedures, or resources',
    'Took actions to address deficits (for example: insufficient sleep, distrust)',
];

export const teamResilienceResilienceManifestationQuestions = [
    'Alerted one another to potential problems',
    'Communicated about situational changes (for example: mission, resources)',
    'Responded to challenges when they occurred',
    'Sought assistance',
    'Ensured all team members were comfortable speaking up',
    'Offered backup or support when team members needed help (for example: overloaded, competing)',
    'Maintained regular, necessary work routines while under stress',
    'Intentionally switched to and from \u201cnormal\u201d mode to \u201cemergency\u201d mode',
    'Relied upon team members with the most relevant expertise',
    'Identified \u201cwhat was not working\u201d in managing a challenging situation and made real-time changes',
    'Monitored team members\u2019 health',
];

export const teamResilienceStressorsQuestions = [
    'Information overload?',
    'Uncertainty or doubt?',
    'Lack of sleep?',
    'Emotional stressors?',
    'Interpersonal conflicts or disagreements?',
    'Prolonged separation from family?',
    'Time pressures?',
    'Loud noises?',
    'Confined spaces?',
    'Heavy workload?',
    'Insufficient resources?',
    'Physical demand?',
    'Hazardous conditions?',
    'Staffing or skill shortage?',
    'Personnel changes?',
];

export const teamResilienceStressorsSubCategories = [
    teamResilienceDefaultStressorsSubCategory.Psychological,
    teamResilienceDefaultStressorsSubCategory.Psychological,
    teamResilienceDefaultStressorsSubCategory.Psychological,
    teamResilienceDefaultStressorsSubCategory.Psychological,
    teamResilienceDefaultStressorsSubCategory.Psychological,
    teamResilienceDefaultStressorsSubCategory.Psychological,
    teamResilienceDefaultStressorsSubCategory.External,
    teamResilienceDefaultStressorsSubCategory.External,
    teamResilienceDefaultStressorsSubCategory.External,
    teamResilienceDefaultStressorsSubCategory.Workload,
    teamResilienceDefaultStressorsSubCategory.Workload,
    teamResilienceDefaultStressorsSubCategory.External,
    teamResilienceDefaultStressorsSubCategory.External,
    teamResilienceDefaultStressorsSubCategory.Workload,
    teamResilienceDefaultStressorsSubCategory.Workload,
];

export const teamResilienceName = 'Team Resilience';
export const teamResilienceDescription =
    'Evaluates team dynamics, adaptability, and collective ability to overcome challenges and stress.';
